import { OwnershipTypes, OwnershipTypesMap } from './types';

export const userTitleOptions = [
  { key: 'Ms', value: 'Ms' },
  { key: 'Mr', value: 'Mr' },
  { key: 'Mrs', value: 'Mrs' },
  { key: 'Miss', value: 'Miss' },
  { key: 'Dame', value: 'Dame' },
  { key: 'Doctor', value: 'Doctor' },
  { key: 'Lady', value: 'Lady' },
  { key: 'Lord', value: 'Lord' },
  { key: 'Professor', value: 'Professor' },
  { key: 'The Rt Hon', value: 'The Rt Hon' },
  { key: 'Sir', value: 'Sir' },
  { key: 'Reverend', value: 'Reverend' },
  { key: 'The Hon', value: 'The Hon' },
];

export const userTypeOptions = [
  {
    key: 'landlord',
    value: 'Landlord',
    description:
      'Add properties to your portfolio, create tenancies and manage the entire tenancy process.',
    icon: 'key',
  },
  // {
  //   key: 'manager',
  //   value: 'Property manager',
  //   description:
  //     "Manages property on behalf of landlords, they don't own the property and require legal consent from the landlord.",
  //   more: 'This type of account can be setup as a company or sole trader.',
  //   icon: 'homes',
  // },
  {
    key: 'tenant',
    value: 'Tenant',
    description:
      'Link to a landlords tenancy, make payments and find your next tenancy.',
    icon: 'human',
  },
];

export const ownershipTypeOptions = [
  {
    key: OwnershipTypes.soleOwned,
    value: OwnershipTypesMap[OwnershipTypes.soleOwned],
    description:
      'You own the property and are the registered owner in Land Registry.',
  },
  {
    key: OwnershipTypes.soleMortgaged,
    value: OwnershipTypesMap[OwnershipTypes.soleMortgaged],
    description:
      'You own the property via a lender and have possession and maintain the upkeep.',
  },
  {
    key: OwnershipTypes.companyOwned,
    value: OwnershipTypesMap[OwnershipTypes.companyOwned],
    description:
      'A company owns the property and is the registered owner in Land Reqistry.',
  },
  {
    key: OwnershipTypes.companyMortgaged,
    value: OwnershipTypesMap[OwnershipTypes.companyMortgaged],
    description:
      'A company owns the property via a lender. It has possession and maintains the upkeep.',
  },
];

export const tenancyStatusMap = {
  futureTenancy: 'FUTURE TENANCY',
  currentTenancy: 'CURRENT TENANCY',
  pastTenancy: 'PAST TENANCY',
};
